<template>
  <div class="container-fluid d-flex flex-column leaderboard-page"
    :class="{ 'mx-4': corporate !== '', 'h-100 w-100': corporate === '' }">

    <div class="mt-3" v-if="!showDirectlyUser && (showGroup || corporate !== '')">
      <b-row align-h="between">
        <b-col md="12" lg="6">
          <div class="page-leaderboard-title">
            <h3 class="text-left">
              <button class="btn back-btn text-dark" v-if="showGroup" @click="goBack">
                <b-icon-arrow-left></b-icon-arrow-left>
              </button>
              <span v-if="corporate !== ''">({{ corporate }})</span>
            </h3>
          </div>
        </b-col>
      </b-row>
    </div>

    <div class="mt-3" v-if="showFilters && !loading">
      <b-row v-if="isAdmin">
        <b-col cols=12 md=auto class="pr-0 mt-3 pl-md-4">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'fromDate'">FROM</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <b-form-datepicker :date-format-options="dateFormatOption" :min="minFromDate" :max="maxFromDate"
                :disabled="!isAdmin" class="filter-date-input-white notranslate" :id="'fromDate'" type="date" v-model="fromDate">
              </b-form-datepicker>
            </div>
          </div>
        </b-col>
        <b-col cols=12 md=auto class="pr-0 mt-3 pl-md-4">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'toDate'">TO</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <b-form-datepicker :date-format-options="dateFormatOption" :min="minToDate" :max="maxToDate"
                :disabled="!isAdmin" class="filter-date-input-white notranslate" :id="'toDate'" type="date" v-model="toDate">
              </b-form-datepicker>
            </div>
          </div>
        </b-col>
        <b-col cols=12 md=auto class="pr-0 mt-3 pl-md-4" v-if="!showDirectlyUser">
          <div class="d-flex flex-row align-items-center">
            <label class="filter-label" :for="'teams'">TEAMS</label>
            <div class="ml-2 w-100 px-4 px-md-1">
              <multiselect v-model="selectedTeams" :options="allTeams" :disabled="!isAdmin" placeholder="Select Teams"
                title="Select teams which you want to display" :multiple="true" :close-on-select="false"
                :clear-on-select="false">
              </multiselect>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row cols=12 class="mt-4 mr-lg-5 d-flex flex-row-reverse" v-if="isAdmin">
        <b-col cols=6 lg=2>
          <button class="btn btn-outline-success ef-btn ef-btn-banner w-100" @click="applyFilter">Apply Filter</button>
        </b-col>
        <b-col cols=6 lg=2>
          <button v-if="showClearFilter" class="btn btn-outline-success ef-btn ef-btn-banner w-100"
            @click="clearFilter">Clear Filter</button>
        </b-col>
      </b-row>
    </div>

    <div class="mt-4 d-flex flex-column flex-fill align-items-center w-100" v-if="!loading && isMountedEnded&& (showDirectlyUser || totalRows > 0)">
      <b-table responsive="xl" :items="tableData" :fields="activeFields" :per-page="perPage" 
        :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" tbody-class="notranslate"
        class="w-100"
        tbody-tr-class="row-class-left row-class-white"
        thead-tr-class="row-class-left row-class-header row-class-grey-header" ref="table">

        <template v-slot:head(topPerformers)="data">
          <div class="w-100" v-html="data.field.label"></div>
        </template>

        <template v-slot:cell(teamName)="row">
          <div :class="(sortBy == 'teamName' ? 'row-data-black' : '')" @click="
            isViewAll(
              row.item.teamName + ':' + Math.ceil(row.item.totalTime / 60) + ':' + row.item.totalWorkout + ':' + (row.index + 1),
              true
            )
            ">
            {{ row.item.teamName | limitTitle }}</div>
        </template>

        <!--- COLUMNS FOR LEADERBOARD STARTS --->

        <template v-slot:cell(totalTime)="row">
          <div :class="(sortBy == 'totalTime' ? 'row-data-black' : '')">
            {{ row.item.workoutMin !=="NaNm" ? row.item.workoutMin : "--" }}
          </div>
        </template>

        <template v-slot:cell(effectiveWorkoutSec)="row">
          <div :class="(sortBy == 'effectiveWorkoutSec' ? 'row-data-black' : '')">
            {{ row.item.effectiveWorkoutMin !=="NaNm" ? row.item.effectiveWorkoutMin : "--"}}
          </div>
        </template>

        <template v-slot:cell(avgAccuracy)="row">
          <div :class="(sortBy == 'avgAccuracy' ? 'row-data-black' : '')">
            {{ row.item.avgAccuracy !=="NaN%" ? row.item.avgAccuracy : "--"}}
          </div>
        </template>

        <template v-slot:cell(noOfWorkouts)="row">
          <div :class="(sortBy == 'noOfWorkouts' ? 'row-data-black' : '')">
            {{ row.item.noOfWorkouts || "--"  }}
          </div>
        </template>

        <template v-slot:cell(topPerformers)="row">
          <div class="d-flex align-items-center">
            <div class="image-thumbnail mr-4 mt-1 mb-3 text-light" v-for="user in row.item.users.slice(0, 3)"
              :key="user.email" :style="{ background: '#418fde' }" v-b-tooltip.hover :title="user.name">
              {{ user.name.charAt(0).toUpperCase() }}
              <div class="font-12 font-weight-bold row-data-grey">{{ getProfileName(user) }}</div>
            </div>
          </div>
        </template>

        <!--- COLUMNS FOR LEADERBOARD ENDS --->

        <!--- COLUMNS FOR VIEW ALL STARTS --->
        <template #cell(rank)="row">
          <div class="rank-bg d-flex justify-content-center align-items-center font-weight-bold">
            <span class="rank-bg d-flex justify-content-center align-items-center" :class="getRankColor(showGroup ? row.index + 1 : row.item.rank)">{{
              showGroup ?  row.index + 1 : row.item.rank }}</span>
          </div>
        </template>

        <template v-slot:cell(name)="row">
          <div class="d-flex align-items-center ml-3">
            <div class="image-thumbnail mr-1" :style="{ background: '#418fde' }" v-b-tooltip.hover :title="row.item.name">
              {{ row.item.name.charAt(0).toUpperCase() }}
            </div>
            <div class="font-14 font-weight-500 row-data-grey pl-3" :class="(sortBy == 'name' ? 'row-data-black' : '')"
              data-toggle="tooltip" :title="row.item.name">
              {{ row.item.name | limitTitle }}
            </div>
          </div>
        </template>

        <!--- COLUMNS FOR VIEW ALL ENDS --->

      </b-table>
      <b-pagination v-if="showDirectlyUser" size="sm" pills v-model="currentPage" :total-rows="totalRowsUsers"
        :per-page="perPage" aria-controls="my-table" id="perPageSelect"></b-pagination>
    </div>

    <div v-if="!loading && !showDirectlyUser && totalRows === 0">
      <noData class="pt-5"></noData>
    </div>

    <loader v-if="loading || !isMountedEnded"></loader>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import Multiselect from 'vue-multiselect'
import { BIcon, BIconArrowLeft } from 'bootstrap-vue'

const { mapActions, mapGetters, mapState, mapMutations } = createNamespacedHelpers(
  "admin/leaderboard"
);

const { mapActions: b2bActions } = createNamespacedHelpers(
  "b2bUser"
);

import noData from "../components/NoDataAvailable.vue";
export default {
  data: function () {
    const isSortable = this.$store.state.userInfo.role === "CorporateHR";
    return {
      corporate: '',
      showGroup: false,
      showUserData: false,
      currentPage: 1,
      perPage: 20,
      tableData: null,
      sortBy: 'workoutMin',
      sortDesc: true,
      /**
       * Table fields for Leaderboard page
       * */
      teamFields: [
        { key: "teamName", label: "Name", thClass: "name-col-width", tdClass: "align-middle font-14 font-weight-500 name-col-width row-data-grey hover-primary", sortable: false },
        { key: "totalTime", sortable: isSortable, label: "Workout Mins.", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "noOfWorkouts", sortable: isSortable, label: "Workouts completed", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "avgAccuracy", sortable: isSortable, label: "Avg. Accuracy", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "effectiveWorkoutSec", sortable: isSortable, label: "Effective Workout Mins", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "topPerformers", label: "Top 3 Performers (Workout Mins)", tdClass: "align-middle" },
      ],
      /**
       * Table fields for View all page
       * */
      userFields: [
        { key: "rank", label: "Rank", thClass: "text-center align-middle headClass", tdClass: "align-middle" },
        { key: "name", sortable: isSortable, tdClass: "align-middle pr-2  pl-0 font-14 font-weight-500 name-col-width row-data-grey", thClass: "pl-3 name-col-width" },
        { key: "totalTime", sortable: isSortable, label: "Workout Mins.", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "noOfWorkouts", sortable: isSortable, label: "Workouts completed", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "avgAccuracy", sortable: isSortable, label: "Avg. Accuracy", tdClass: "align-middle font-14 font-weight-500 row-data-grey" },
        { key: "effectiveWorkoutSec", sortable: isSortable, label: "Effective Workout Mins", tdClass: "align-middle font-14 font-weight-500 row-data-grey" }
      ],
      fields: [],
      selectedTeams: [],
      profilePic: false,
      teamWorkoutTime: 0,
      teamWorkouts: 0,
      rank: 0,
      fromDate: '',
      toDate: '',
      minFromDate: undefined,
      maxFromDate: undefined,
      minToDate: undefined,
      maxToDate: undefined,
      selectTeamName: '',
      dateFormatOption: { year: 'numeric', month: 'short', day: '2-digit' },
      showFilters: true,
      showTeams: true,
      someList: [],
      showDirectlyUser: false,
      totalRecords: 0,
      showColumns: [],
      userId: null,
      isMountedEnded: false,
    };
  },
  components: {
    noData,
    Multiselect,
    BIcon,
    BIconArrowLeft
  },
  computed: {
    ...mapGetters(["leaderBoardList", "rankedTeams", "rankedUsers"]),
    ...mapState(["loading", "viewAllActive", "teamName", "filters", "allTeams"]),

    corporateConfig() {
      const userInfo = this.$store.state.userInfo;
      return userInfo?.corporate?.config;
    },
    activeFields() {
      const index = this.fields?.findIndex(col => col.key === 'rank');
      if (!this.corporateConfig?.pages?.leaderboard?.showMedals && index >= 0) {
        this.fields.splice(index, 1);
      }
      return this.fields;
    },
    totalRows() {
      if (!this.viewAllActive) {
        return this.rankedTeams ? this.rankedTeams.length : 0;
      } else {
        return this.leaderBoardList[this.teamName]?.viewAll
          ? this.leaderBoardList[this.teamName].viewAll.length
          : 0;
      }
    },
    totalRowsUsers() {
      return this.someList ? this.totalRecords > 0 ? this.totalRecords : this.someList.length : 0; // added by mayank
    },
    isAdmin() {
      return this.$store.state.userInfo?.role === "CorporateHR";
    },
    showClearFilter() {
      if ((this.fromDate && this.toDate) || this.selectedTeams) {
        return (this.fromDate !== '' || this.toDate !== '') || this.selectedTeams.length;
      }
    }
  },

  filters: {
    limitTitle(val) {
      if (val?.length > 10) {
        return val.substring(0, 10).concat("...");
      } else {
        return val
      }
    },
  },
  watch: {
    showGroup: function (val, oldVal) {
      /**
       * Set table fields and table items for leaderboard
       * */
      if (val === false) {
        this.tableData = this.rankedTeams;
        this.fields = this.teamFields;
      }
      /**
       * Set table fields and table items for view all page
       * */
      else {
        this.tableData = this.rankedUsers;
        this.fields = this.userFields;
      }
    },
    showUserData: function (val, oldVal) {
      this.loadRanks();
      this.fields = this.userFields;
      /** Added By Mayank */
      if (this.showColumns && this.showColumns.length > 0) {
        let arr = [];
        for (const data of this.tableData) {
          let obj = {};
          for (const cols of this.showColumns) {
            obj[cols] = data[cols];
          }
          arr.push(obj);
        }
        this.tableData = arr;
        let fieldsArr = [];
        for (const data of this.fields) {
          for (const cols of this.showColumns) {
            if (data.key === cols) {
              fieldsArr.push(data);
            }
          }
        }

        this.fields = fieldsArr;
      }
    },
    filters: function (val) {
      this.fromDate = val.fromDate;
      this.toDate = val.toDate;
      this.selectTeamName = val.teamNames;
      this.sortBy = val.sortBy;
      this.sortDesc = val.sortDesc;
      this.selectedTeams = val.selectedTeams;
      this.totalRecords = val.totalRecords; //Added by mayank
      this.showColumns = val.showColumns; //Added by mayank
    },
    fromDate: function (val) {
      
      this.minToDate = new Date(val);
    },
    toDate: function (val) {
      this.maxFromDate = new Date(val);
    },
    sortBy: function () {
      this.loadRanks();
      const filter = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        selectedTeams: this.selectedTeams
      }
      this.setFilters(filter)
      this.updateFilters();
    },
    sortDesc: function () {
      this.loadRanks();
      const filter = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        selectedTeams: this.selectedTeams
      }
      this.setFilters(filter)
      this.updateFilters();
    }
  },

  methods: {
    ...mapActions(["loadLeaderBoardData", "setTeamName", "setFilters", "setIsAdmin", "updateFilters", "getOrg", "setFiltersortBy", "setFiltersortDesc"]),
    ...b2bActions(["setIsTitle", "setTitle"]),

    loadData() {
      if (this.showDirectlyUser) {
        this.someList = this.getDisplayList();
        this.tableData = this.someList;
        this.fields = this.userFields;
      } else {
        this.tableData = this.rankedTeams;
        this.fields = this.teamFields;
      }
    },
    getDisplayList: function () {
      let list = [];
      for (const [key, value] of Object.entries(this.leaderBoardList)) {
        if (value && value.viewAll && value.viewAll.length > 0) {
          for (const element of value.viewAll) {
            list.push(element);
          }
        }
      }
      return list;
    },
    getRankColor(rank) {
      switch (rank) {
        case 1:
          return "bg-yellow";
        case 2:
          return "bg-gray";
        case 3:
          return "bg-brown";
        default:
          return "bg-black";
      }
    },

    loadRanks() {
      if(this.showDirectlyUser){
        this.someList = this.getDisplayList();
      }else{
        this.someList = this.tableData;
      }
      if(!this.someList){
        return;
      }
      if (this.sortBy) {
        // this.someList.sort((a, b) => {
        //   const modifier = this.sortDesc ? -1 : 1;
        //   return a[this.sortBy] > b[this.sortBy] ? modifier : -modifier;
        // });
      }
      this.someList.forEach((item, index) => {
        item.rank = index + 1;
      });
      this.tableData = this.totalRecords > 0 ? this.someList.slice(0, this.totalRecords) : this.someList; //added by mayank
      let totalLength = this.tableData.length;

      let currentUser = this.someList.find(obj => obj.userId === this.userId);

      if (currentUser && currentUser.rank > totalLength) {
        this.tableData[totalLength - 1] = currentUser;
      }
    },
    isViewAll(team, isActice) {
      let teamDetails = team.split(":");
      let teamName = teamDetails[0];
      this.teamWorkoutTime = teamDetails[1];
      this.teamWorkouts = teamDetails[2];
      this.rank = teamDetails[3];
      this.setTeamName({ teamName, isActice });
      this.showGroup = isActice;
    },
    getProfileName(user) {
      let name = (user.name + "").split(" ")[0]; // getting username or email
      if (name.length > 4) {
        // check name length is more than 5 charactor long
        return name.substr(0, 4) + "..";
      } else {
        return name;
      }
    },
    async applyFilter() {
      const filters = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        selectedTeams: this.selectedTeams
      }
      this.setFilters(filters);
      await this.loadLeaderBoardData();
      this.loadData();
      this.showGroup = false
    },
    async clearFilter() {
      const filters = {
        fromDate: '',
        toDate: '',
        sortBy: 'workoutMin',
        sortDesc: true,
        selectedTeams: []
      }
      this.setFilters(filters);
      await this.updateFilters();
      await this.loadLeaderBoardData();
      this.loadData();
      this.showGroup = false
    },
    goBack() {
      this.selectedTeams = [];
      this.showGroup = false;
    },
    /**
     * Need to update later
     * */
    viewFirstTeam() {
      if (this.tableData[0]) {
        const team = this.tableData[0];
        let teamName = team.teamName;
        this.teamWorkoutTime = Math.ceil(team.totalTime / 60);
        this.teamWorkouts = team.noOfWorkouts;
        this.rank = team.ranking;
        this.setTeamName({ teamName, isActive: true });
        this.showGroup = true;
      }
    },
    viewUsers() {
      this.showUserData = true;
    }
  },

  async mounted() {
    this.corporate = (this.$route.params?.corporate) ? this.$route.params.corporate : '';
    await this.getOrg(this.corporate);
    await this.loadLeaderBoardData();
    this.loadData();
    this.setIsAdmin(this.isAdmin);
    let ctx = this;
    this.setIsTitle(true);
    this.setTitle("Leaderboard");

    const userInfo = this.$store.state.userInfo;
    if (userInfo && userInfo.corporate) {
      this.userId = userInfo.userId;
      const corporateConfig = userInfo.corporate.config;
      const leaderboardConfig = corporateConfig?.pages?.leaderboard;

      this.showFilters = leaderboardConfig?.showFilters ?? this.showFilters;
      this.showTeams = leaderboardConfig?.showTeams ?? this.showTeams;
      let showUserList = (leaderboardConfig && !leaderboardConfig?.showTeams) ?? this.showDirectlyUser;
      if (showUserList) {
        this.showDirectlyUser = showUserList;
        this.viewUsers();
      }
      if (!this.showDirectlyUser && !this.showTeams) {
        this.viewFirstTeam();
      }
    }

    if (!this.showDirectlyUser && this.showTeams) {
      window.onpopstate = function (event) {
        if (ctx.showGroup) {
          ctx.$router.push({ path: "/leaderboard" });
        }
      };
    }

    this.isMountedEnded = true
  },

  beforeDestroy() {
    this.setIsTitle(false);
    this.setTitle("");
  },

};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
::v-deep .multiselect__tags {
  min-height: 0;
  padding: 0px 40px 0 8px;
  background: #FFFFFF !important;
  border: 2px solid #73BC44;
  border-radius: 5px !important;
  //height: 34px !important;
  min-width: 165px !important;
  display: flex;
  flex-direction: column;
  align-items: start;
}

::v-deep .multiselect__placeholder {
  margin: 5px 0 5px 10px;
  color: #969B92;
  font-weight: 500;
}

::v-deep .text-muted {
  color: #969B92 !important;
  font-weight: 500;
}

::v-deep .multiselect__single {
  margin-bottom: 0px !important;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #141513 !important;
}

::v-deep .multiselect--disabled .multiselect__select {
  background: none !important;
}

::v-deep .multiselect__select:before {
  color: #73BC44 !important;
  border-color: #73BC44 transparent transparent;
}

::v-deep .multiselect__tags-wrap {
  //display: flex !important;
  //align-items: center !important;
  padding-top: 8px;
}

::v-deep .multiselect__tag {
  margin-bottom: 0;
}

::v-deep .multiselect__input {
  position: relative;
  display: inline-block;
  min-height: 20px;
  margin-bottom: 8px;
}

::v-deep .multiselect--active:not(.multiselect--above) .multiselect__tags {
  padding-top: 8px;
}

.page-leaderboard-title {
  font-size: 20px;
  font-weight: bolder;
}

.profile-name {
  font-size: 14px;
  text-transform: capitalize !important;
}

.align-center {
  line-height: 1;
}

.font-medium {
  font-size: 16px;
}

.first-rank {
  color: #73bc44;
}

.second-rank {
  color: yellow;
}

.third-rank {
  color: red;
}

.rank-bg {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  color: white;
}


.image-thumbnail {
  color: #FFFFFF;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 16px;
  text-align: center;
  line-height: 30px;
  cursor: default;
}

.view-all {
  width: 80px;
}

.table-class {
  font-size: 16px;
  font-family: Kanit-Regular, Kanit;

  th {
    div {
      text-align: left;
    }
  }

  td {
    text-align: left;
  }
}

.filter-label-col {
  padding: 0 0 0 35px;
}

.filter-label {
  margin: 0;
  padding: 0;
  top: 50%;
  font-weight: bold;
  font-size: 12px;
  line-height: 18px;
  color: #969B92;
}

.filter-date-input-white {
  height: 34px !important;
  width: auto !important;
}

.ef-btn {
  padding: 5px 10px;
  height: 34px;
  font-size: 14px;
}

// Mobile

@media only screen and (max-device-width: 780px) {
  .filter-label {
    width: 15%;
  }
}

.table-responsive {
  overflow-x: unset !important;
}
</style>
